module.exports = __webpack_public_path__ + "media/images/home/summary/timecard-23e73b13a4440b25eea5f31d0e6d5b83.jpg";